import { render, staticRenderFns } from "./ProfileDoctor.vue?vue&type=template&id=734c4e12&scoped=true&"
import script from "./ProfileDoctor.vue?vue&type=script&lang=js&"
export * from "./ProfileDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDoctor.vue?vue&type=style&index=0&id=734c4e12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734c4e12",
  null
  
)

export default component.exports